import { UserJobVacancyState } from "@/types/userJobVacancy.type";

const getBaseUrl = (url: string) => `https://rakamin.id/${url}`;

export const ASSETS = {
  general: {
    studentImage: getBaseUrl("images/bgpicturemobile-40b0008f-513e-4744-be76-6c517c5c7ce5.png"),
    studentImage2: getBaseUrl("images/bgpictureright-a9aa8406-a65f-47f4-a2be-143c6e001af4.png"),
    dummyCourseImg: getBaseUrl("images/courseimg-926c5f9b-8fcb-41dd-acf7-08c5dfc57c37.png"),
    loader: getBaseUrl("images/loader1-b2c64132-ac46-4791-9ba6-3c65bc58fb98.gif"),
    loaderblack: getBaseUrl("files/loadinganimationblack-35c51207-f5e9-461b-b10d-f4606554a55a.svg"),
    loaderWhite: getBaseUrl(
      "images/loadinganimationwhite-97c15be4-dc8c-46e7-83ff-91cd023d024b.gif"
    ),
    Profil01: getBaseUrl("images/profil01-b964f4a5-6ea1-4d5b-9d23-e44e1ef93871.png"),
    logoTelkomselWhite: getBaseUrl(
      "images/telkomsellogowhite-f94356d6-82fb-4b8b-9710-fc237431904a.png"
    ),
    logoRakamin: getBaseUrl("images/logorakamin-0be22621-0fbd-4fe0-b8f1-0633a92005e3.png"),
    logoRakaminWhite: getBaseUrl(
      "images/Logo_Rakamincde26e00e0424062bf0f5f746b1e390b-8b22b355-a6fe-4c00-8d2b-daadcfa61c8f.png"
    ),
    reminderIllustration: getBaseUrl(
      "images/reminderillustration-4fe37a5a-39a8-4296-a1d7-0ae5bf13b851.png"
    ),
    stars: getBaseUrl("images/stars-da29932d-82a1-42a5-80ed-b6b03924378d.png"),
  },
  landing: {
    bgAlumni: getBaseUrl("images/testimonies-bae62409-5172-491b-8fdc-3dbcba5acb72.jpg"),
    bgFeatureProg: getBaseUrl("images/bgfeatureprog-37764663-329e-4570-9de5-ea4b47cca85a.png"),
    bgRakaminValue1: getBaseUrl(
      "images/bgpicrakaminvalue1-28137e85-def3-4d25-93ab-5e397862dad5.png"
    ),
    bgRakaminValue2: getBaseUrl(
      "images/bgpicrakaminvalue2-fe269aeb-61af-48c8-a690-143af84c1758.png"
    ),
    bgRakaminValue3: getBaseUrl(
      "images/bgpicrakaminvalue3-99fe9690-f7a7-48f3-9e70-04db9d8d674b.png"
    ),
    certificateEAF: getBaseUrl("images/certificateeaf-fa1ec0ba-8cca-45b3-ad0b-47a10bac10e7.png"),
    heroIllustration: getBaseUrl(
      "images/heroillustration-bd1f3038-4c93-4c1f-9487-f190833c50a3.png"
    ),
    bgHero: getBaseUrl("images/bgherov2-8d4ea2f8-d9e9-4681-bafc-d88375994634.png"),
    bgHeroMobile: getBaseUrl("images/landingbgheromobile-fa71a707-db52-4574-9796-30ab26954341.png"),
    heroPhaseExploration: getBaseUrl(
      "images/herophaseexploration-d550db45-457f-45e7-8113-19a2eaa23a68.png"
    ),
    heroPhaseLearning: getBaseUrl(
      "images/herophaselearning-1629f369-65e6-448b-a7f6-bbf0e6806846.png"
    ),
    heroPhaseJob: getBaseUrl("images/herophasejob-4d9058c3-e6d3-463e-a714-dfd3598fcde9.png"),
    uspTestimonialBackground: getBaseUrl(
      "images/Landing_Page_BGUSP-8e1303ba-52cb-45fd-9e5e-1806e924aba2.png"
    ),
  },
  customLanding: {
    heroIllustration: getBaseUrl(
      "images/customlandingheroillustration-2bd956d7-ae9c-4cb1-8c73-dec6f9939629.png"
    ),
    heroIllustrationMobile: getBaseUrl(
      "images/customlandingheroillustrationmobile-22350b99-4ad9-4f32-9a70-bc4c0fa83048.png"
    ),
  },
  careerBootcampLanding: {
    bgCardGojek: getBaseUrl("images/bgcardgojek-a49a81f8-2697-4035-bb49-6a2713f9c6ce.png"),
    bgCardMandiri: getBaseUrl("images/bgcardmandiri-caa13b2e-6d3c-408c-bc67-6f226ac9d921.png"),
    bgCardTelkomsel: getBaseUrl("images/bgcardtelkomsel-1490b231-a2c0-4925-b96b-9eaa60041e1d.png"),
    bgCardTokopedia: getBaseUrl("images/bgcardtokopedia-21ba1339-6176-4aac-9f7d-cbdf30dfa7f0.png"),
    bgHero: getBaseUrl("images/bgherocareerbootcamp-a30c01f8-acf6-4928-ae91-5481fe2d7afb.png"),
    bgHero2: getBaseUrl("images/bgherocareerbootcamp2-a9fb803f-f7d2-4f99-9885-884189b82c35.png"),
    bgTrial: getBaseUrl("images/bgtrialcourse-fd095c0f-8aa3-4a37-8a6d-face40461ddc.png"),
    eafLogo: getBaseUrl("images/eaflogo-fa5f6280-f9f1-4507-98b4-ad431adc5557.png"),
    whyIllustration: getBaseUrl(
      "images/onlinebootcampwhyillustration-a2213e76-e228-4bf9-ba3d-eff931d5dd21.png"
    ),
    bgHeroOnline: getBaseUrl(
      "images/careerbootcampbgheroonline-58dd3498-6304-4ff9-9008-19bbea2e4789.png"
    ),
    bgJourney: getBaseUrl("images/careerbootcampjourney-1e7ddacd-8457-477f-9897-39687cf97e7f.png"),
  },
  prakerjaLanding: {
    hero: getBaseUrl("images/heroprakerja-4678f919-3f49-4a34-b784-ddc33dfce629.png"),
    aboutDesktop: getBaseUrl(
      "images/bgaboutprakerjadesktop-fd7d8041-1132-4a4a-9cfa-d6da3b35394d.jpg"
    ),
    aboutMobile: getBaseUrl(
      "images/bgaboutprakerjamobile-12718367-4d04-4cac-a58d-8b0a3a23273c.png"
    ),
    faqDesktop: getBaseUrl("images/csprakrjadesktop-2f3f955d-b895-476b-9519-c98c33f6ceab.jpg"),
    faqMobile: getBaseUrl("images/csprakerjamobile-d512e717-5c64-413f-9cc3-d2b443daee9c.jpg"),
    bgWhyRakamin: getBaseUrl("images/assetwavewhite-e864d934-53fd-4756-b6d8-40a7096f9cec.png"),
  },
  marketingLanding: {
    bgHero: getBaseUrl("images/heromarketing-004d0a8c-4a1c-4fbf-8b11-a5b92bedbb0d.png"),
    bgWhyJgp: getBaseUrl("images/bgjgp-ff4b0ae5-dc03-4477-ba33-c8ffc330c8bc.png"),
    bgLine: getBaseUrl("images/bgline-37d2f2cb-cfa0-4915-9ae9-6007da9111f2.png"),
    bgLineMobile: getBaseUrl("images/bglinemobile-8aa9350c-44a0-4c4a-a234-44bc916195ca.png"),
    bgComparison: getBaseUrl("images/bgcomparison-e048b124-3d56-4be8-95a8-2d1c8b3adae0.png"),
  },
  careerPath: {
    person: getBaseUrl("images/careerpathperson-d4ddeffc-ff50-4e32-8b13-228d0e0936dd.png"),
    dmBronze: getBaseUrl("images/dmbronze-65cd085c-5539-40ea-b591-8c4c969d954d.gif"),
    dsBronze: getBaseUrl("images/dsbronze-f8eba2ee-6ca6-4433-8af6-a04362d2b5c7.gif"),
    uxBronze: getBaseUrl("images/uxbronze-59351463-e159-4c52-a29d-6c9fa2a688d9.gif"),
    dmIllustration: getBaseUrl("images/dmillustration-98961b95-7d5e-4abb-8b0f-71fdbd506f3f.gif"),
    dsIllustration: getBaseUrl("images/dsillustration-4e648b00-0e65-4690-8fcd-91024fe32650.gif"),
    uxIllustration: getBaseUrl("images/uxillustration-a7ae01f4-3a14-4a76-9b41-3fc683e058d8.gif"),
    findCareerIllustration: getBaseUrl(
      "images/findcareerpathillustration-9e29ca9d-99b0-4f0d-aa8f-579460210bd7.gif"
    ),
    unknownBadgeTooltipAnimation: getBaseUrl(
      "images/unknownbadgetooltipanimation-5966836e-9467-45c1-ac8a-bcee26f01628.gif"
    ),
    unknownCareerBadge: getBaseUrl(
      "images/unknowncareerbadge-dd378f27-888a-48a4-8766-6632bd50cbc6.gif"
    ),
  },
  course: {
    backgroundCertificate: getBaseUrl(
      "images/Background_Certificate-eaf27218-9a82-46ab-a27e-da6969aa0a5a.png"
    ),
    successIllustration: getBaseUrl(
      "images/successIllustration-303f77d8-d05d-4b63-b21c-ba003f7009b5.png"
    ),
    failedIllustration: getBaseUrl(
      "images/failedIllustration-8f18ad99-a349-41e2-9a4a-4c1c163ca808.png"
    ),
    myclassHero: getBaseUrl(
      "images/backgroundheromyclass-61e86ab8-19eb-474c-b5ef-59aaba6c93f4.jpeg"
    ),
  },
  biodataFullfillment: {
    sideBanner1: getBaseUrl(
      "images/biodatafullfillmentsidebanner1-d3eeb0ef-48c2-406c-8517-160c7684125b.png"
    ),
    sideBanner2: getBaseUrl(
      "images/biodatafullfillmentsidebanner2-0c0c32e9-e9d1-471f-978f-6ba3b8c8b781.png"
    ),
    sideBanner3: getBaseUrl(
      "images/biodatafullfillmentsidebanner3-260f4c70-18ad-48af-88d8-3386314db5c4.png"
    ),
  },
  pbi: {
    achievementCertificate: getBaseUrl(
      "images/pbiachievementcertificate-e9363801-81dc-4e46-8e70-25cd4b9bff2e.png"
    ),
    completionCertificate: getBaseUrl(
      "images/pbicompletioncertificate-46efa194-5924-48c5-9ead-5daffbf07294.png"
    ),
    competencyCertificate: getBaseUrl(
      "images/pbicompetencycertificate-1ae5b3b2-11a0-4c88-a541-3f809e7698cb.png"
    ),
    aboutVipBg1: getBaseUrl("images/pbiaboutvipbg1-a9aeb1bf-d265-46a7-9a0b-089f7614aa26.png"),
    aboutVipBg2: getBaseUrl("images/pbiaboutvipbg2-8b0d4b56-4bd8-4f0b-b122-543758d88964.png"),
    aboutVipBg3: getBaseUrl("images/pbiaboutvipbg3-6323ec29-db25-4f6a-b4c9-913fd453e710.png"),
    aboutVipBg4: getBaseUrl("images/pbiaboutvipbg4-e5a110e6-b316-4d8f-966f-009fd95d79c5.png"),
    aboutVipBg5: getBaseUrl("images/pbiaboutvipbg5-a45a059b-93b6-42a6-b8c5-a65f0db28aeb.png"),
    aboutVipBg6: getBaseUrl("images/pbiaboutvipbg6-8fb1ecc8-b64f-4d78-aedb-38326e404290.png"),
    aboutVipBg7: getBaseUrl("images/pbiaboutvipbg7-b4a034ce-b88c-476c-ab62-10075ff1eac3.png"),
    introPersonWeb: getBaseUrl("images/pbiintropersonweb-7460fd0e-d4b0-4a05-9658-2562008274e6.png"),
    introPersonMobile: getBaseUrl(
      "images/pbiintropersonmobile-51926098-3cd9-4e9c-8c39-7a5e1d32284d.png"
    ),
    bgHero: getBaseUrl("images/bgherovwx-7cda1a5f-f345-42bc-bfce-87bcefd7af9d.png"),
    benefitIllustration1: getBaseUrl(
      "images/pbibenefitillustration1-a51b109b-dc2b-40f8-9156-088b8f09dfad.png"
    ),
    benefitIllustration2: getBaseUrl(
      "images/pbibenefitillustration2-2e695ce6-30e7-4ea1-9ebc-60711f5e2f21.png"
    ),
    benefitIllustration3: getBaseUrl(
      "images/pbibenefitillustration3-5cfb5cc2-c677-4de3-95ec-5cdaa6423d83.png"
    ),
    benefitIllustration4: getBaseUrl(
      "images/pbibenefitillustration4-58179d42-eae3-401a-bc96-5d0d5587b0a0.png"
    ),
    vipJourney: getBaseUrl("images/pbivipjourney-53c3f5fa-e274-4b2c-94c7-a91df76510b7.png"),
    basicJourney: getBaseUrl("images/pbibasicjourney-c7d1a66b-86f2-4d64-941b-b56774dd9e33.png"),
  },
  explorePbi: {
    ctaIllustration: getBaseUrl(
      "images/explorepbictaillustration-bbb5ed67-1d6d-4784-8580-12133b4c4965.png"
    ),
    bgCta: getBaseUrl("images/explorepbibgcta-56d414a2-6fbf-4cb1-85a8-5ddfcca4e68e.png"),
    bgCta2Web: getBaseUrl("images/explorepbibgcta2web-63f77d58-7265-4c31-b27c-e1a99f1867b5.png"),
    bgCta2Mobile: getBaseUrl(
      "images/explorepbibgcta2mobile-50936ee0-4a23-4e88-af85-817da07ee390.png"
    ),
    bgBannerWeb: getBaseUrl(
      "images/explorepbibgbannerweb-ecf34754-440a-42e1-b03c-1afffad5d6a5.png"
    ),
    bgBannerMobile: getBaseUrl(
      "images/explorepbibgbannermobile-e80e2539-237c-49ca-a71d-9efac24988a9.png"
    ),
  },
  detailPbi: {
    bgMentoring: getBaseUrl("images/pbidetailbgmentoring-19388077-8fad-40a0-b090-8cef3be925a1.png"),
    bgTask: getBaseUrl("images/pbidetailbgtask-9f4e3562-7ccd-4ddc-9df4-2181817e369c.png"),
    bgReading: getBaseUrl("images/pbidetailbgreading-77a172d8-46c3-4d9c-a0b0-63966b735571.png"),
    bgSurvey: getBaseUrl("images/pbidetailbgsurvey-1604945f-79d6-4a9f-840d-fb63e650e8db.png"),
    bgVideoLearning: getBaseUrl(
      "images/pbidetailbgvideolearning-5f84828b-4485-4dcc-a879-cad62a614a2b.png"
    ),
  },
  testimonialPbi: {
    bgResearch: getBaseUrl("images/pbiresearchbg-1c260592-26e5-4290-8a06-ca1eb47c3e9a.png"),
  },
  checkout: {
    vipTalentPool: getBaseUrl("images/viptalentpool-1903d445-0a6f-45e3-97d1-b4d6cedbfa77.png"),
    payAnimation: getBaseUrl("images/payanimation-2640346d-ef8b-4d15-929b-2952b35d1a3b.gif"),
    payRejectedAnimation: getBaseUrl(
      "images/paymentrejectedanimation_1-e8ba071c-0ddb-44fd-a22f-11afc1c0554d.gif"
    ),
    paySucceedAnimation: getBaseUrl(
      "images/paymentsucceed_1-8895ee53-4ff7-403e-9547-e3382a2b5c98.gif"
    ),
  },
  japForCampus: {
    pbiBenefit: getBaseUrl("images/benefit1-80f69336-1948-4be3-b5ed-0a54cabe4c52.png"),
    careerPreparationBenefit: getBaseUrl(
      "images/benefit2-14089cbb-7053-4473-b833-4476910bf104.png"
    ),
    talentHiringBenefit: getBaseUrl("images/benefit3-12989ec1-1012-4879-ae5c-f06999bc0620.png"),
  },
  hiringDashboard: {
    bgBanner: getBaseUrl("images/hiringdashboardbgbanner-f12edcfa-4555-4807-9c50-07d9bca89331.png"),
    bgAssessmentInfo: getBaseUrl(
      "images/bgassessmentinfo-6d3f19cc-b0d2-460e-ae8a-d136f65b3971.png"
    ),
    matchmakingExample: getBaseUrl("images/matchmaking-example.png"),
    pipelineDetailForm: {
      recruiterSide: {
        [UserJobVacancyState.INTERVIEW]: getBaseUrl(
          "images/interviewrecruiter-e3f93fed-9bce-4d04-8fc2-7688d519b4b9.png"
        ),
        [UserJobVacancyState.ASSESSMENT]: getBaseUrl(
          "images/assessmentrecruiter-35fc8066-4e16-4a72-a3fb-57beb98ae836.png"
        ),
        [UserJobVacancyState.MEDICAL_CHECKUP]: getBaseUrl(
          "images/medicalrecruiter-74caa5ba-4d1b-41f2-aa26-bd824f8f4051.png"
        ),
        [UserJobVacancyState.OFFERING]: getBaseUrl(
          "images/offeringrecruiter-1685f903-5492-4e0b-944b-d6ee6b7e3a0c.png"
        ),
      },
      talentSide: {
        [UserJobVacancyState.INTERVIEW]: getBaseUrl(
          "images/interviewstudent-8634cec8-f204-4fb0-8376-cb805fde380b.png"
        ),
        [UserJobVacancyState.ASSESSMENT]: getBaseUrl(
          "images/assessmentstudent-3c3450d1-bb78-4a7d-9e6b-fc3e057a93c8.png"
        ),
        [UserJobVacancyState.MEDICAL_CHECKUP]: getBaseUrl(
          "images/medicalstudent-7243af83-d595-40ee-9dd2-ee94bf415ce3.png"
        ),
        [UserJobVacancyState.OFFERING]: getBaseUrl(
          "images/offeringstudent-507f1299-2f98-4135-856f-180c0dff7ac7.png"
        ),
      },
    },
  },
  assessment: {
    internetMeterFile: getBaseUrl(
      "images/internetmeterfile-ae26acaa-9830-4835-9da9-cb87ccee431b.png"
    ),
    completeAssessment: getBaseUrl("images/complete-exam-illustration.png"),
  },
  proctoring: {
    truncatedIdentityCard: getBaseUrl("images/KTPpotong-506d2073-6b63-4002-ad90-e7ff8df99c96.png"),
    blurredIdentityCard: getBaseUrl(
      "images/KTPtidakjelas-68271013-3c75-4608-995c-dd65821948c3.png"
    ),
    correctIdentityCard: getBaseUrl("images/KTPbenar-39fffb68-6dcf-447d-a59c-114762b4ff54.png"),
    truncatedFaceIdentityCard: getBaseUrl(
      "images/wajahktppotong-518c6aae-34c1-4bf2-a978-78810709da67.png"
    ),
    blurredFaceIdentityCard: getBaseUrl(
      "images/wajahktptidakjelas-ab9e58f6-da71-4788-bca3-52710afb5349.png"
    ),
    correctFaceIdentityCard: getBaseUrl(
      "images/wajahktpbenar-49847ff8-1611-459e-a1a9-62d62baf5ea8.png"
    ),
  },
  jobVacancies: {
    registrationClosed: getBaseUrl("images/registration-closed-jobs.svg"),
  },
};
